<template>
  <div
    :class="{ 'visible': isOpen }"
    class="modal-wrapper"
  >
    <div class="modal">
      <div class="modal-header">
        <h2 class="is-size-5">
          Assign to Event(s)
        </h2>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div
            v-if="loadingEvents"
            class="column divisions-wrapper smaller"
          >
            Loading...
          </div>
          <div
            v-else
            class="column divisions-wrapper smaller"
          >
            <span v-if="selectedEvents.length > 0">
              <EventItem
                v-for="event in selectedEvents"
                :key="event._id"
                :event="event"
                @toggleEvent="toggleEvent"
              />
            </span>
            <div
              v-else
              class="has-text-centered"
            >
              No events yet
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a
          href="#"
          class="button is-light"
          @click.prevent="closeModal(false)"
        >Cancel</a>
        <a
          href="#"
          :class="{ 'is-loading': submitting }"
          class="button is-warning has-text-weight-bold"
          :disabled="!isValid || submitting"
          @click.prevent="submitForm"
        >
          Save
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import CurrencyField from '@/components/inputs/CurrencyField'
import EventItem from '@/components/admin/events/EventItem'

import moment from 'moment'

export default {
  name: 'EventSelectModal',
  components: {
    TextField,
    CurrencyField,
    EventItem
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'create'
    },
    initialData: {
      type: [Object, Boolean],
      default: false
    },
  },
  data () {
    return {
      //  Values
      selectedEvents: [],
      submitting: false,
      loadingEvents: false
    }
  },
  mounted () {
    this.loadEvents()
  },
  computed: {
    isValid () {
      return this.validateFields()
    }
  },
  watch: {
    currentTab () {

      if (this.currentTab === 'existing') {
      }
    }
  },
  methods: {
    toggleEvent (params) {
      const i = this.selectedEvents.findIndex(d => {
        return d._id === params._id
      })

      let d = this.selectedEvents[i]
      d.selected = params.selected
      this.selectedEvents.splice(i, 1, d)
      this.validateFields()
    },
    validateFields () {
      let valid = false
      let selected = this.selectedEvents.filter(event => {
        return event.selected
      })
      if (selected.length > 0) {
        valid = true
      }
      return valid
    },
    submitForm () {
      let events = []

      this.selectedEvents.map(event => {
        if (event.selected) {
          events.push(event._id)
        }
      })

      let data = {
        match: {
          _id: this.initialData.divisionId
        },
        update: {
          events: events
        }
      }

      this.$store
        .dispatch('admin/UPDATE_DIVISION_EVENT', data)
        .then(res => {
          this.submitting = false
          this.closeModal(true)
          this.$toasted.success('Added division to event(s)')
        })
        .catch(err => {
          this.submitting = false
          this.$toasted.error('Error adding division to event(s)')
          console.log(err)
        })
    },
    closeModal (refresh) {
      this.$emit('closeModal', refresh)
    },
    loadEvents () {
      this.loadingEvents = true
      this.$store
        .dispatch('admin/GET_EVENTS')
        .then(res => {
          if (res.data.events.length > 0) {
            res.data.events.map(event => {
              event.selected = false
            })
          }

          return res.data.events
        })
        .then(data => {
          this.selectedEvents = data
          this.loadingEvents = false
        })
    }

  }
}
</script>

<style lang="scss">
  .tabs.is-justified{
    li {
      width: 50%;
    }
  }
</style>
